module.exports = __webpack_public_path__ + "img/435765080ad6783276799df483b9eda2.png";